import type { UserRole } from "@/app/userRole";

// 멤버 등급(=backend RoleType) 표시 순서. 권한이 높은 순서다. 드롭다운·필터 옵션이 공유한다.
export const memberTierOrder: readonly UserRole[] = ["admin", "member"];

export const memberTierLabels: Record<UserRole, string> = {
  admin: "관리자",
  member: "멤버",
};

export function memberTierLabel(tier: UserRole): string {
  return memberTierLabels[tier] ?? tier;
}

// 인라인 등급 변경 드롭다운 옵션.
export const memberTierOptions: readonly { value: UserRole; label: string }[] = memberTierOrder.map(
  (tier) => ({ value: tier, label: memberTierLabels[tier] }),
);
